import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, flatMap, catchError, map } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import EmployeeApi from 'signin-app/api/employee-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration, defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import * as Actions from './actions';
import * as Selectors from './selectors';
const checkInEmployee = action$ => action$.pipe(ofType(Actions.checkInEmployee.type), mergeMap(({ payload }) => {
    const { accessToken, employeeId, pin, selectedHour, selectedMinute, groupId, successMessage } = payload;
    let estimatedCheckoutTime;
    if (selectedHour !== undefined && selectedMinute !== undefined) {
        // We need to send the time formatted correctly. For example, if the user has chosen 5 minutes past 9 in the morning,
        // we need to send '09:05', rather than '9:5'.
        // It would probably be best to use a proper library to render the time in the correct ISO8601 format
        const selectedHourWithZero = `0${selectedHour}`.slice(-2);
        const selectedMinuteWithZero = `0${selectedMinute}`.slice(-2);
        estimatedCheckoutTime = `${selectedHourWithZero}:${selectedMinuteWithZero}`;
    }
    return EmployeeApi.checkIn(accessToken, employeeId, pin, groupId, estimatedCheckoutTime).pipe(flatMap(response => {
        dispatchStatusMessageEvent({
            message: successMessage,
            statusType: 'Success',
            sticky: false,
            e2eId: '',
            duration: defaultSuccessDuration,
        });
        return [Actions.checkInEmployeeSuccess.action(response)];
    }), catchError(e => {
        dispatchStatusMessageEvent({
            message: getRestClientErrorMessage(e),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkInEmployeeFailed.action(e));
    }));
}));
const onSelectedHoursChanged = (action$, state$) => action$.pipe(ofType(Actions.selectLeaveHours.type), map(({ payload }) => {
    var _a, _b;
    const timeOptions = Selectors.checkoutTimeOptions(state$.value);
    // Select the lowest possible minute option within the selected hour
    const minutes = Math.min(...((_b = (_a = timeOptions.find(time => time.hour === payload.hours)) === null || _a === void 0 ? void 0 : _a.minutes) !== null && _b !== void 0 ? _b : []));
    return Actions.selectLeaveMinutes.action(minutes);
}));
export default combineEpics(checkInEmployee, onSelectedHoursChanged);
